import { FC, PropsWithChildren, useEffect, useState } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { cn } from '@/utils/classNames.ts';
import Navbar from '@/components/ui/Navbar/Navbar';
import Routes from '@/router/Routes';
import ListIcon from '@/components/ui/icons/ListIcon';
import ProfileIcon from '@/components/ui/icons/ProfileIcon';
import LogoutIcon from '@mui/icons-material/Logout';
import BottomNav from '@/components/ui/BottomNav/BottomNav';
import { useAuthContext } from '@/context/AuthContext';

type LayoutProps = PropsWithChildren<{
  mainClassName?: string;
  showLogo?: boolean;
  showSearch?: boolean;
}>;

const Layout: FC<LayoutProps> = ({ mainClassName, showLogo = true, showSearch = true }) => {
  const [searchQuery, setSearchQuery] = useState('');
  const navigate = useNavigate();
  const location = useLocation();
  const { logout } = useAuthContext();

  useEffect(() => {
    setSearchQuery('');
  }, [location.pathname]);

  const navItems = [
    {
      icon: <ListIcon className="w-5 h-5" />,
      onClick: () => navigate(Routes.ADMIN_DASHBOARD),
    },
    {
      icon: <ProfileIcon className="w-6 h-6" />,
      onClick: () => navigate(Routes.ADMIN_USERS),
    },
    {
      icon: <LogoutIcon sx={{ width: '24px', height: '24px' }} />,
      onClick: logout,
    },
  ];

  return (
    <div className="min-h-screen flex flex-col lg:flex-row bg-bg-light">
      <Navbar
        logoLink={Routes.ADMIN_DASHBOARD}
        showLogo={showLogo}
        showSearch={showSearch}
        searchQuery={searchQuery}
        onSearchChange={setSearchQuery}
        navItems={navItems}
      />
      <main className={cn(
        'flex-1 px-4 py-6 pb-24 sm:px-6 sm:pb-24 lg:px-8 lg:pb-24 lg:max-h-screen lg:overflow-auto',
        mainClassName
      )}>
        <Outlet context={{ searchQuery }} />
      </main>
      <BottomNav 
        items={navItems}
        variant="admin"
      />
    </div>
  );
};

const Admin = {
  Layout,
};

export default Admin;
